import { createRouter, createWebHistory } from 'vue-router'
import { LoginCallback, navigationGuard } from '@okta/okta-vue'
import { bootstrapGate } from '../bootstrapGate'
import { devSkipAuth } from '../devMode'
import Home from '../views/Home.vue'
import IssueGallery from '../views/IssueGallery'
import IssueDetails from '../views/IssueDetails'

const requiresAuth = !devSkipAuth

const router = createRouter({
  history: createWebHistory("storyfinder"),
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        requiresAuth
      }
    },
    {
      path: '/oktasuccess',
      component: LoginCallback
    },
    {
      path: '/brand/:brandId/issues',
      name: 'issue_gallery',
      component: IssueGallery,
      meta: {
        requiresAuth
      }
    },
    {
      path: '/issue/:issueId',
      name: 'issue',
      component: IssueDetails,
      meta: {
        requiresAuth
      }
    },
    {
      path: '/about',
      name: 'about',
      component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
      meta: {
        requiresAuth
      }
    },
    {
      path: '/documentation',
      name: 'documentation',
      component: () => import(/* webpackChunkName: "about" */ '../views/Documentation.vue'),
      meta: {
        requiresAuth
      }
    },
    {
      path: '/search',
      name: 'search',
      component: () => import('../views/Searchnew.vue'),
      props: (route) => ({ query: route.query.q }),
      meta: {
        requiresAuth
      }
    },
    // {
    //   path: '/*',
    //   component: Home
    // }
  ]
})

router.beforeEach(async () => {
  await bootstrapGate
})
router.beforeEach(navigationGuard)

export default router
